/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-globals */
import React, { useCallback, useEffect, useState } from 'react';
import { Bookmark, Pencil, Trash } from '@saleshandy/icons';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import {
  OverlayPopover,
  Placement,
} from '../../../../../shared/design-system/components/overlay';
import SaveFilterModal from '../../modal/save-filter-modal';
import { getSavedFilterListAPI } from '../../../helpers/leads.api';
import { SaveFilterModalVarient } from '../../modal/save-filter-modal/types';
import Transfer from '../../../../../shared/design-system/components/transfer/transfer';
import Button from '../../../../../shared/design-system/components/atoms/button';
import { leadFinderViewOnly } from '../../../../../shared/utils/user-details';
import toaster from '../../../../../shared/toaster';
import { RootState } from '../../../../../store/root-reducer';
import {
  LeadFinderPrimaryTab,
  LeadFinderSecondaryTab,
  SavedFilterTab,
} from '../../../types';
import Icon from '../../../../../shared/design-system/components/atoms/icon';

export default function SavedFilter({
  handleGeneratePayload,
  isLoading,
  applyPendingFilters,
  hasPendingFilters,
  isPartialFilterApplied = false,
}) {
  const history = useHistory();
  const location = useLocation();
  const [savedFilters, setSavedFilters] = useState<any>([]);
  const activeLeadType = useSelector(
    (state: RootState) => state.leadFinderV2.activeLeadType,
  );
  const isBulkModeActive = useSelector(
    (state: RootState) => state.leadFinderV2.bulkPeopleSearch.isBulkModeActive,
  );
  const savedFilterTab =
    activeLeadType === LeadFinderPrimaryTab.COMPANY
      ? SavedFilterTab.COMPANIES
      : SavedFilterTab.PEOPLE;

  const [selectedSavedFilter, setSelectedSavedFilter] = useState<any>();
  const [showPopOver, setshowPopOver] = useState<boolean>(false);
  const [showSaveFilter, setshowSaveFilter] = useState<boolean>(false);
  const [showEditFilter, setshowEditFilter] = useState<boolean>(false);
  const [showDeleteFilter, setshowDeleteFilter] = useState<boolean>(false);
  const [showAppliedFilter, setshowAppliedFilter] = useState<boolean>(false);
  const isLeadFinderViewOnly = leadFinderViewOnly();

  const [activeFilter, setActiveFilter] = useState(null);

  const onToggle = () => {
    setshowPopOver(!showPopOver);
  };
  const onToggleAppliedFilter = () => {
    setshowAppliedFilter(!showAppliedFilter);
  };
  const hideSaveFilterModal = () => {
    setshowSaveFilter(false);
  };
  const hideEditSaveFilterModal = () => {
    setshowEditFilter(false);
  };
  const hideDeleteSavedFilterModal = () => {
    setshowDeleteFilter(false);
  };

  const getSavedFilters = async () => {
    try {
      const res = await getSavedFilterListAPI(savedFilterTab);
      if (res) {
        const mappedArray = res.payload.map((item) => ({
          ...item,
          // eslint-disable-next-line no-underscore-dangle
          key: item?._id,
        }));
        setSavedFilters(mappedArray);
      }
    } catch (e: any) {
      if (!e?.isHandled) {
        toaster.error(
          e.message || "Couldn't fetch saved filters. Please try again.",
        );
      }
    }
  };
  const buildQueryString = (filterObject: any, historyObj: any) => {
    const queryParams: string[] = [];

    // Helper to add a query param
    const addParam = (paramKey: string, paramValue: string) => {
      if (
        paramValue !== undefined &&
        paramValue !== null &&
        paramValue !== ''
      ) {
        queryParams.push(`${paramKey}=${encodeURIComponent(paramValue)}`);
      }
    };

    // Helper to get the exclude key for a filter
    const getExcludeKey = (filterKey: string): string =>
      `exclude${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`;

    Object.entries(filterObject).forEach(([key, value]: [string, any]) => {
      if (value === null || value === undefined) {
        return;
      }

      // Handle simple primitive values (like decision_maker: 1, is_b2b: 0)
      if (typeof value === 'number' || typeof value === 'string') {
        addParam(key, String(value));
        return;
      }

      // Handle objects with includes/excludes structure
      if (typeof value === 'object' && !Array.isArray(value)) {
        // Handle isUnknown-only case (when isUnknown is 1, no filter values)
        if (value.isUnknown === 1 && !value.includes && !value.min) {
          addParam(`${key}_isUnknown`, '1');
          return;
        }

        // Handle includes array
        if (value.includes && Array.isArray(value.includes)) {
          value.includes.forEach((item: string) => {
            addParam(key, item);
          });
        }

        // Handle excludes array
        if (value.excludes && Array.isArray(value.excludes)) {
          const excludeKey = getExcludeKey(key);
          value.excludes.forEach((item: string) => {
            addParam(excludeKey, item);
          });
        }

        // Handle min/max range (for dropdowns like company_size, total_experience, etc.)
        if (value.min !== undefined || value.max !== undefined) {
          const min = value.min ?? '';
          const max = value.max ?? '';
          // Format: "min-max" or "min+" or "<max"
          if (min && max) {
            addParam(key, `${min}-${max}`);
          } else if (min && !max) {
            addParam(key, `${min}+`);
          } else if (!min && max) {
            addParam(key, `<${max}`);
          }
        }

        // Handle exists flag (for company_funding_date with "all time")
        if (value.exists === true) {
          addParam(key, 'all time');
        }

        // Handle exactMatch flag
        if (value.exactMatch === 1 || value.exactMatch === true) {
          addParam(`${key}_exactMatch`, '1');
        }

        // Handle shouldSearchPast flag
        if (value.shouldSearchPast === 1 || value.shouldSearchPast === true) {
          addParam(`${key}_shouldSearchPast`, '1');
        }

        // Handle isUnknown flag (when there are also filter values)
        if (value.isUnknown !== undefined) {
          addParam(`${key}_isUnknown`, String(value.isUnknown));
        }

        return;
      }

      // Handle simple arrays (fallback for any array values)
      if (Array.isArray(value)) {
        value.forEach((item: string) => {
          addParam(key, String(item));
        });
      }
    });

    const queryString = queryParams.join('&');
    // Get current lead type and subtab from URL
    const currentPath = historyObj.location.pathname;
    const pathParts = currentPath.split('/');
    const leadType = pathParts[3] || LeadFinderPrimaryTab.PEOPLE; // Default to people
    const subtab = pathParts[4] || LeadFinderSecondaryTab.TOTAL; // Default to total
    const finalUrl = `/v2/leads/${leadType}/${subtab}?${queryString}`;

    // Push to route
    historyObj.push(finalUrl);
    // Don't call searchLeads() directly - let the useEffect watching location.search handle it
    // This prevents duplicate API calls
    setshowPopOver(false);
  };
  const applySavedFilter = (option: any) => {
    buildQueryString(option?.searchQuery, history);
  };

  useEffect(() => {
    if (!isLeadFinderViewOnly) {
      getSavedFilters();
    }
  }, [isLeadFinderViewOnly]);

  useEffect(() => {
    if (savedFilters && savedFilters?.length > 0) {
      const payload = handleGeneratePayload();
      // eslint-disable-next-line no-restricted-syntax
      for (const f of savedFilters) {
        if (_.isEqual(f?.searchQuery, payload)) {
          setActiveFilter(f);
        }
      }
    }
    return () => {
      setActiveFilter(null);
    };
  }, [location?.search, savedFilters]);

  const searchLead = useCallback(() => {
    if (applyPendingFilters) {
      applyPendingFilters();
    }
  }, [applyPendingFilters]);

  const hasPendingApplied =
    typeof hasPendingFilters === 'function' && hasPendingFilters();

  const hasFiltersToSave =
    !!location?.search || isBulkModeActive || hasPendingApplied;

  return (
    <div
      className={`v2-saved-filters-container ${
        isLeadFinderViewOnly ? 'v2-saved-filter-container-custom' : ''
      }`}
    >
      <div className="v2-saved-filters-button">
        <Button
          onClick={() => searchLead()}
          variant={Button.Variant.Primary}
          iconLeft={<Icon identifier="search" className="search-icon" />}
          disabled={
            (!hasPendingFilters ? !location?.search : !hasPendingFilters()) ||
            isLoading ||
            isPartialFilterApplied
          }
        >
          <span className="search-txt">Search</span>
        </Button>
      </div>
      {!isLeadFinderViewOnly && (
        <div className="v2-saved-filters-details">
          <div className="v2-saved-filters">
            <OverlayPopover
              show={showPopOver}
              onToggle={onToggle}
              rootClose={true}
              className="prospect-tag-popover"
              content={
                <>
                  <Transfer
                    options={savedFilters}
                    filterOption={(value, option) =>
                      option?.name?.toLowerCase().includes(value.toLowerCase())
                    }
                    optionRenderer={(option: any) => (
                      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          setSelectedSavedFilter(option);
                          applySavedFilter(option);
                        }}
                      >
                        <p className="v2-search-seved-filter">{option.name}</p>
                        <div className="d-flex">
                          <Pencil
                            className="edit-icon"
                            onClick={(e) => {
                              setshowEditFilter(true);
                              onToggle();
                              e?.stopPropagation();
                              setSelectedSavedFilter(option);
                            }}
                          />
                          <Trash
                            onClick={(e) => {
                              setshowDeleteFilter(true);
                              onToggle();
                              e?.stopPropagation();
                              setSelectedSavedFilter(option);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    showSearch
                    searchPlaceholder="Search"
                  />
                </>
              }
              placement={Placement.TopStart}
            >
              <div className="d-flex align-items-center">
                <div className="icon">
                  <Bookmark />
                </div>
                {/* eslint-disable-next-line */}
                <span onClick={() => setshowPopOver(true)}>Saved Filters</span>
              </div>
            </OverlayPopover>
            <OverlayPopover
              show={showAppliedFilter}
              onToggle={onToggleAppliedFilter}
              className="prospect-tag-applied"
              content={
                <div>
                  <p className="v2-saved-applied-filter">
                    Saved Filter Applied
                  </p>
                  <p className="applied-filter-active">{activeFilter?.name}</p>
                </div>
              }
              placement={Placement.TopStart}
              rootClose={true}
            >
              <div className="d-flex align-items-center">
                {activeFilter && (
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                  <div
                    onClick={() => setshowAppliedFilter(true)}
                    className="v2-saved-filter-dot d-block"
                  />
                )}
              </div>
            </OverlayPopover>
          </div>

          <div className="v2-save-filter">
            {/* eslint-disable-next-line */}
            <span
              onClick={() => {
                const canSaveFilter = hasFiltersToSave && !activeFilter;
                if (canSaveFilter) {
                  setshowSaveFilter(true);
                }
              }}
              className={`v2-save-filter-txt ${
                !hasFiltersToSave || activeFilter ? 'v2-disable-save-filter' : ''
              }`}
            >
              Save Filter
            </span>
          </div>

          {showSaveFilter && (
            <SaveFilterModal
              show={showSaveFilter}
              varient={SaveFilterModalVarient.Save}
              onHide={hideSaveFilterModal}
              isLoading={true}
              getSavedFilters={getSavedFilters}
              handleGeneratePayload={handleGeneratePayload}
            />
          )}
          {showEditFilter && (
            <SaveFilterModal
              show={showEditFilter}
              varient={SaveFilterModalVarient.Edit}
              onHide={hideEditSaveFilterModal}
              isLoading={true}
              selectedSavedFilter={selectedSavedFilter}
              getSavedFilters={getSavedFilters}
            />
          )}
          {showDeleteFilter && (
            <SaveFilterModal
              show={showDeleteFilter}
              varient={SaveFilterModalVarient.Delete}
              onHide={hideDeleteSavedFilterModal}
              isLoading={true}
              selectedSavedFilter={selectedSavedFilter}
              getSavedFilters={getSavedFilters}
            />
          )}
        </div>
      )}
    </div>
  );
}
